export const mboxes = {
  bannerMbox: 'for-home:GraphicBanner',
  customerAbTestMbox: 'OE-411-mbox',
  disclaimerMbox: 'for-home:disclaimer',
  interstitialMbox: 'homepage-interstitial-mbox',
  layoutTestMbox: 'layoutTest',
  prospectAbTestMbox: 'OE-414-mbox',
  quickLinksMbox: 'for-home:QuickLinks',
  topCardsMbox: 'for-home:CardTop',
  whyOriginMbox: 'for-home:CardTopLight',
};
